import { AttendanceContextlessPoliciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useAttendanceContextlessPolicies = () => {
  const { data, loading } = useQuery(AttendanceContextlessPoliciesDocument)
  const policies = data?.attendance?._policies

  return {
    loading,
    brazilianExportAccess: !!policies?.brazilianExportAccess.can,
    accessEditSettings: !!policies?.accessEditSettings.can,
    companyReadAttendance: !!policies?.companyReadAttendance.can,
  }
}
